import {createStandardAction} from "typesafe-actions";
import {IErrorMessage, IPerformanceMessage} from "./types";

export const trackPerformance = createStandardAction("@log/TRACK_PERFORMANCE")<IPerformanceMessage>();
export const trackError = createStandardAction("@log/TRACK_ERROR")<IErrorMessage>();
export const flushErrorBuffer = createStandardAction("@log/FLUSH")<number>();